export const MobileRegex=/^09\d{9}$/
export const ShabaRegex=/[0-9]{24}/
export const PersianAlphabet=/^[\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC ]+$/
export const EnglishAndNumberOnly=/^[A-Za-z0-9]+$/
export const EmailRegex=/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/